import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CameraPlusIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M14 8v1.795c0 1.297 0 1.945-.262 2.44a2.36 2.36 0 0 1-1.048 1.013c-.514.252-1.186.252-2.53.252H5.84c-1.344 0-2.016 0-2.53-.252a2.36 2.36 0 0 1-1.048-1.012C2 11.74 2 11.092 2 9.795v-3.01c0-1.298 0-1.946.262-2.442A2.36 2.36 0 0 1 3.31 3.331c.514-.252 1.186-.252 2.53-.252H8.3m3.9 2.895V2.5m-1.8 1.737H14m-3.6 4.052c0 1.28-1.075 2.316-2.4 2.316S5.6 9.568 5.6 8.29 6.675 5.974 8 5.974s2.4 1.037 2.4 2.315" /></svg>
  );
}

export default CameraPlusIcon;
